var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// eslint-disable-next-line import/no-extraneous-dependencies
import { debounce } from 'lodash';
// eslint-disable-next-line import/no-extraneous-dependencies
import React, { useEffect, useState } from 'react';
import { FaCheckCircle, FaExclamationTriangle, FaInfoCircle, FaSave } from 'react-icons/fa';
import { ImSpinner2 } from 'react-icons/im';
var Autosave = function (_a) {
    var value = _a.value, enabled = _a.enabled, dirty = _a.dirty, onSave = _a.onSave;
    var _b = useState({
        isSaving: false,
        isError: false,
        isSuccess: false,
    }), autosaveStatus = _b[0], setAutosaveStatus = _b[1];
    var debouncedAutosave = React.useCallback(
    // eslint-disable-next-line @typescript-eslint/no-shadow
    debounce(function (value) {
        setAutosaveStatus(function (oldStatus) { return (__assign(__assign({}, oldStatus), { isSaving: true })); });
        onSave(value)
            .then(function () {
            setAutosaveStatus({ isSaving: false, isError: false, isSuccess: true });
        })
            .catch(function () {
            setAutosaveStatus({ isSaving: false, isError: true, isSuccess: false });
        });
    }, 4000), []);
    useEffect(function () {
        if (!autosaveStatus.isSaving && enabled && dirty) {
            debouncedAutosave(value);
        }
    }, [value, enabled, dirty]);
    return (_jsxs("div", { className: "block pt-4", children: [_jsxs("p", { className: "relative flex items-center flex-1 text-xs font-semibold sm:mb-2 sm:flex-initial", children: [_jsx(FaSave, { className: "mr-2" }), " Autosaving enabled"] }), _jsxs("p", { className: "relative flex-1 h-5 text-xs font-semibold sm:flex-initial", children: [autosaveStatus.isSaving && (_jsxs("span", { className: "flex items-center", children: [_jsx(ImSpinner2, { className: "mr-2 animate-spin" }), " Saving..."] })), !autosaveStatus.isSaving && autosaveStatus.isSuccess && (_jsxs("span", { className: "flex items-center text-green-500", children: [_jsx(FaCheckCircle, { className: "mr-2" }), " Saved"] })), !autosaveStatus.isSaving && autosaveStatus.isError && (_jsxs("span", { className: "flex items-center text-red-500", children: [_jsx(FaExclamationTriangle, { className: "mr-2 " }), " Error while saving"] })), !autosaveStatus.isSaving && !autosaveStatus.isSuccess && !autosaveStatus.isError && (_jsxs("span", { className: "flex items-center text-blue-400", children: [_jsx(FaInfoCircle, { className: "mr-2" }), " Waiting for changes"] }))] })] }));
};
export { Autosave as default };
